import { render, staticRenderFns } from "./ProcessChartLoader.vue?vue&type=template&id=251e3127&"
import script from "./ProcessChartLoader.vue?vue&type=script&lang=js&"
export * from "./ProcessChartLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports